import FlagsManager from './manager'
import FlagsSingleton from './singleton'

export default FlagsSingleton
export { FlagsManager }
